<div class="content">
    <p>
        Rainfall is recorded to 9 am each day. This data is from the Bureau of Meteorology and is unchecked from automatic equipment.
    </p>
</div>
